<template>
  <div class="wrapper">
    <div class="title">{{ title }}</div>
    <div class="content">
      <div v-if="content" class="content-text">
        {{ content }}
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "content"]
};
</script>
<style scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 1em;
}

.title {
  font-weight: 700;
  flex-shrink: 0;
  text-align: end;
  width: 200px;
  padding: 0.5em;
}
.content {
  flex-grow: 1;
}
.content-text {
  color: #000000a2;
  padding: 0.5em 0;
}
</style>
